import ReactDOM from 'react-dom/client';

import settings from '@src/conf';
import { consoleUtils, storageUtils, versionUtils } from '@src/corelib/utils';

import App from './App';
// import { sentryPlugin } from './plugins';
import router from './router';


function init() {
  return new Promise((resolve, reject) => {
    const currentVersion = versionUtils.getPackageVersion();
    const previousVersion = versionUtils.getAppVersion();
    if (previousVersion !== currentVersion) {
      Promise.all([storageUtils.clearLocalStorage()])
        .then(() => {
          versionUtils.setAppVersion(currentVersion);
          resolve({ version: currentVersion });
        })
        .catch((error) => {
          reject(error);
        });
    }
    else {
      resolve({ version: currentVersion });
    }
  });
}

init()
  .then(() => {
    if (import.meta.env.MODE === 'production') {
      consoleUtils.userWarning();
    }

    // Init settings
    settings.init();
    // Init sentry config
    // sentryPlugin.init({ context: { router } });

    // Render the app
    const rootElement = document.getElementById('root');
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
  })
  .catch((error) => {
    console.error('App Init Error: ', error);
  });
